module.exports = __webpack_public_path__ + "a990cae60e554d5a05eda39d13fba11c.svg";